import { createApp } from 'vue/dist/vue.esm-bundler'
import { createPinia } from 'pinia'

import filters from './money.js'

import ProductsComponent from './components/ProductsComponent.vue'
import TotalsComponent from './components/TotalsComponent.vue'
import FormComponent from './components/FormComponent.vue'
import WarrantyComponent from './components/WarrantyComponent.vue'

const pinia = createPinia()
const app = createApp({})

app.use(pinia)

app.config.globalProperties.$filters = filters

app.component('ProductsComponent', ProductsComponent)
app.component('TotalsComponent', TotalsComponent)
app.component('FormComponent', FormComponent)
app.component('WarrantyComponent', WarrantyComponent)

app.mount('#app')
